import { Button, Card, Flex, Form, Input, Layout, Typography } from 'antd'
import { useAttemptListener } from 'dev-masters-react-kit'
import { attemptRegister, RegisterDTO } from '../../utils/redux/authSlice'
import { listenerMiddleware, useAppDispatch } from '../../utils/redux/store'
import './auth.scss'
import ParticlesBackground from '../../components/ParticlesBackground'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const { Title } = Typography

export default function Register() {
  const [registerForm] = Form.useForm<RegisterDTO>()
  const dispatch = useAppDispatch()
  const { t } = useTranslation('common')

  function onFinish(values: RegisterDTO) {
    dispatch(attemptRegister(values))
  }

  useAttemptListener({
    listenerMiddleware: listenerMiddleware,
    attempt: attemptRegister,
    onFulfilled: () => {
      console.log('registered successfully')
    },
  })

  return (
    <>
      <ParticlesBackground />
      <Layout className="auth">
        <Flex flex={1} justify="center" align="center">
          <Card style={{ width: '100%', maxWidth: 500, margin: '20px' }}>
            <Title level={3} style={{ textAlign: 'center', marginBottom: 24 }}>
              {t('register')}
            </Title>
            <Form form={registerForm} onFinish={onFinish} className="register" layout="vertical">
              <Form.Item
                name="email"
                label={t('email')}
                rules={[
                  { required: true, message: 'Please input your email!' },
                  { type: 'email', message: 'Invalid email!' },
                ]}
              >
                <Input placeholder={t('email')} />
              </Form.Item>

              <Form.Item
                name="password"
                label={t('password')}
                rules={[{ required: true, message: 'Please input your password!' }]}
              >
                <Input.Password placeholder={t('password')} />
              </Form.Item>

              <Form.Item
                name="name"
                label={t('name')}
                rules={[{ required: true, message: 'Please input your name!' }]}
              >
                <Input placeholder={t('name')} />
              </Form.Item>

              <Form.Item
                name="phone"
                label={t('phone')}
                rules={[{ required: true, message: 'Please input your phone!' }]}
              >
                <Input placeholder={t('phone')} />
              </Form.Item>

              <Form.Item
                name="city"
                label={t('city')}
                rules={[{ required: true, message: 'Please input your city!' }]}
              >
                <Input placeholder={t('city')} />
              </Form.Item>

              <Form.Item
                name="businessType"
                label={t('businessType')}
                rules={[{ required: true, message: 'Please input your business type!' }]}
              >
                <Input placeholder={t('businessType')} />
              </Form.Item>

              <Form.Item
                name="identifier"
                label={t('identifier')}
                rules={[{ required: true, message: 'Please input your identifier!' }]}
              >
                <Input placeholder={t('identifier')} />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  {t('register')}
                </Button>
              </Form.Item>
              <Flex justify="center">
                <Link to="/">{t('login')}</Link>
              </Flex>
            </Form>
          </Card>
        </Flex>
      </Layout>
    </>
  )
}
